// src/pages/Appointments/i18n/appointments.hi.js

export const appointmentsHiTranslations = {
  menu: {
    groups: {
      appointments: {
        label: "अपॉइंटमेंट्स",
        description: "ग्राहक अपॉइंटमेंट और विज़िट ट्रैकिंग",
      },
    },
    items: {
      appointments_dashboard: "अपॉइंटमेंट डैशबोर्ड",
      book_appointment: "अपॉइंटमेंट बुक करें",
      appointment_calendar: "कैलेंडर व्यू",
      todays_appointments: "आज के अपॉइंटमेंट",
      upcoming_appointments: "आगामी",
      active_visits: "सक्रिय विज़िट",
      pending_approvals: "लंबित अनुमोदन",
      all_appointments: "सभी अपॉइंटमेंट",
      appointment_analytics: "एनालिटिक्स",
    },
    descriptions: {
      appointments_dashboard: "अपॉइंटमेंट और विज़िट स्टेटस का अवलोकन",
      book_appointment: "नया ग्राहक अपॉइंटमेंट शेड्यूल करें",
      appointment_calendar: "कैलेंडर फॉर्मेट में अपॉइंटमेंट देखें",
      todays_appointments: "आज के अपॉइंटमेंट देखें और प्रबंधित करें",
      upcoming_appointments: "अगले 7 दिनों के अपॉइंटमेंट",
      active_visits: "वर्तमान में चेक-इन किए गए ग्राहक",
      pending_approvals: "अनुमोदन की प्रतीक्षा में अपॉइंटमेंट",
      all_appointments: "सभी अपॉइंटमेंट देखें और प्रबंधित करें",
      appointment_analytics: "अपॉइंटमेंट ट्रेंड और एनालिटिक्स",
    },
    quick_access: {
      book_appointment: "अभी बुक करें",
      todays_appointments: "आज",
    },
  },

  appointments: {
    status: {
      scheduled: "निर्धारित",
      confirmed: "पुष्ट",
      pending: "लंबित",
      in_progress: "प्रगति में",
      completed: "पूर्ण",
      cancelled: "रद्द",
      no_show: "नहीं आया",
      rescheduled: "पुनर्निर्धारित",
    },
    visit: {
      check_in: "चेक इन",
      check_out: "चेक आउट",
      start_consultation: "परामर्श शुरू करें",
      complete_visit: "विज़िट पूर्ण करें",
      duration: "अवधि",
      waiting_time: "प्रतीक्षा समय",
    },
    form: {
      customer_name: "ग्राहक का नाम",
      phone: "फोन नंबर",
      email: "ईमेल",
      appointment_date: "अपॉइंटमेंट तिथि",
      appointment_time: "अपॉइंटमेंट समय",
      branch: "शाखा",
      service_type: "सेवा प्रकार",
      notes: "नोट्स",
      reminder_preference: "रिमाइंडर प्राथमिकता",
    },
    actions: {
      book: "अपॉइंटमेंट बुक करें",
      reschedule: "पुनर्निर्धारित करें",
      cancel: "रद्द करें",
      confirm: "पुष्टि करें",
      view_details: "विवरण देखें",
      edit: "संपादित करें",
      delete: "हटाएं",
    },
    messages: {
      booking_success: "अपॉइंटमेंट सफलतापूर्वक बुक किया गया",
      reschedule_success: "अपॉइंटमेंट सफलतापूर्वक पुनर्निर्धारित किया गया",
      cancel_success: "अपॉइंटमेंट रद्द किया गया",
      check_in_success: "ग्राहक सफलतापूर्वक चेक इन किया गया",
      complete_success: "विज़िट सफलतापूर्वक पूर्ण हुई",
    },
  },
};

// Also export as default for the loader
export default appointmentsHiTranslations;
